import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  listing: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'listing' }),
}

export { paths }
